import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "hidden lg:block"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-y-4" }
const _hoisted_3 = { class: "text-gray-500" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "$ x.xx", -1)
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "$ x.xx", -1)
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "$ x.xx", -1)
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "$ x.xx", -1)
const _hoisted_17 = { class: "text-gray-500" }
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = { class: "font-semibold" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "$ x.xx", -1)
const _hoisted_21 = { class: "flex justify-between" }
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "$ x.xx", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarsIcon = _resolveComponent("StarsIcon")!
  const _component_BalLoadingIcon = _resolveComponent("BalLoadingIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BalCard = _resolveComponent("BalCard")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createBlock(_component_BalPopover, { "no-pad": "" }, {
    activator: _withCtx(() => [
      _createVNode(_component_BalBtn, {
        color: "white",
        size: _ctx.upToLargeBreakpoint ? 'md' : 'sm',
        class: "mr-2 p-1 relative",
        circle: _ctx.upToLargeBreakpoint
      }, {
        default: _withCtx(() => [
          (_ctx.upToLargeBreakpoint)
            ? (_openBlock(), _createBlock(_component_StarsIcon, {
                key: 0,
                class: _normalizeClass({ 'mr-2': !_ctx.upToLargeBreakpoint })
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.userClaimsLoading)
            ? (_openBlock(), _createBlock(_component_BalLoadingIcon, {
                key: 1,
                size: "sm"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(/*fNumToken(totalRewards) */ 0) + " HALT ", 1))
        ]),
        _: 1
      }, 8, ["size", "circle"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_BalCard, {
        class: "w-72",
        noBorder: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('totalRewards')) + ":", 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(/* TODO: add endpoint fNumToken(totalRewards)*/ 0) + " HALT", 1),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.fNumToken(_ctx.totalRewardsUSDC)) + " USDC", 1),
                _hoisted_9
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Estimated rewards')) + ":", 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(/*fNumToken(totalRewards) TODO: add endpoint */ 0) + " HALT", 1),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(/*fNumToken(totalRewards) TODO: add endpoint */ 0) + " USDC", 1),
                _hoisted_16
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('availableToClaim')) + ":", 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(/*fNumToken(claimableRewards)*/ 0) + " HALT", 1),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.fNumToken(_ctx.claimableRewardsUSDC)) + " USDC", 1),
                _hoisted_23
              ])
            ]),
            _createVNode(_component_BalBtn, {
              color: "purple",
              flat: "",
              outline: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('claim')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: { name: 'manage-rewards' } }, {
              default: _withCtx(() => [
                _createVNode(_component_BalBtn, {
                  color: "gradient",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('manageRewards')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}